/**
 * Model to hold a single state.
 * Example: Wisconsin, Texas, Iowa, etc
 */
export class State {
    public id: string;
    public name: string;
    public abbreviation: string;
    public countryCode: string;
    public countryId: string;

    public clone(): State {
        const clone: State = new State();
        clone.id = this.id;
        clone.name = this.name;
        clone.abbreviation = this.abbreviation;
        clone.countryCode = this.countryCode;
        clone.countryId = this.countryId;
        return clone;
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object): State {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];

        this.id = data['id'];
        this.name = attrs['name'];
        this.abbreviation = attrs['abbreviation'];
        this.countryCode = attrs['countryCode'];
        this.countryId = attrs['countryId'];

        return this;
    }
}
